import * as CatalogClient from '@shawfloors/catalog-client';
const md5 = require('md5');

import * as Storage from 'Utils/Storage';
import cacheKey from './CacheKey';

export import IPageResult = CatalogClient.Product.IPageResult;
export import IVisualSearchOptions = CatalogClient.NyrisSearch.IVisualSearchOptions;

export function getVisualSearchPage(image: Uint8Array, luminenanceSearch: boolean, options: IVisualSearchOptions): Promise<IPageResult<TrykApi.Catalog.ISearchResult>> {
  return Storage.addOrGetItemAsync(
    cacheKey('nyris', 'search', md5(image), luminenanceSearch.toString(), JSON.stringify(options)),
    () => CatalogClient.NyrisSearch.getVisualSearchPage(image, luminenanceSearch, options));
}
